import { useCompositionStore } from '@/store-pinia/composition';
import { ELEMENT_TYPE_TEXT } from '@/plugins/composition-renderer/constants';
import {
  PRINT_STYLE_FLEX,
  PRINT_STYLE_FLOCK
} from '../../../../utils/constants';
import { useControlLayerStore } from '@/store-pinia/control-layer';
import store from '@/store';
import { GETTER_PRODUCT_PRINT_PLATE } from '@/store/modules/product/getters';
import { adjustChangesets } from '@/store-pinia/control-layer/guard-template';

export default (changesets = []) => {
  let resizeFactor = 1;

  const affectedPrintSide = useCompositionStore().getPrintSideNameOfElement(
    changesets[0].uid
  );
  const affectedPrintPlate =
    useCompositionStore().getPrintSideContent(affectedPrintSide);
  if (
    ![PRINT_STYLE_FLOCK, PRINT_STYLE_FLEX].includes(
      affectedPrintPlate.printStyle
    )
  ) {
    return;
  }

  const adjustedChangesets = changesets.map(changeset => {
    const element = affectedPrintPlate.content.find(
      element => element.uid === changeset.uid
    );

    const potentialChangeSet = {
      ...changeset,
      changeset: {
        height: element.height,
        width: element.width,
        ...changeset.changeset
      }
    };

    if (ELEMENT_TYPE_TEXT !== element.type) {
      return potentialChangeSet;
    }

    const printPlateHeightInMm =
      store.getters[GETTER_PRODUCT_PRINT_PLATE](affectedPrintSide)
        .heightInInch * 25.4;
    const lineHeight =
      useControlLayerStore().configData.minHeightInMm[
        affectedPrintPlate.printStyle
      ];
    const minHeightPerLine = (100 * lineHeight) / printPlateHeightInMm;
    const lines = element.text.split('\n').length;

    const minHeight = lines * minHeightPerLine;

    if (minHeight < potentialChangeSet.changeset.height) {
      return potentialChangeSet;
    }

    // Prevent division by zero (or anything close)
    if (Math.abs(potentialChangeSet.changeset.height) < 0.1) {
      return potentialChangeSet;
    }

    resizeFactor = Math.max(
      minHeight / potentialChangeSet.changeset.height,
      resizeFactor
    );

    return potentialChangeSet;
  });

  if (1 === resizeFactor) {
    return;
  }

  adjustChangesets(
    adjustedChangesets.map(changeset => {
      changeset.changeset.height = resizeFactor * changeset.changeset.height;
      changeset.changeset.width = resizeFactor * changeset.changeset.width;
      return changeset;
    })
  );
};
